






































import { defineComponent, getCurrentInstance,ref,watch } from '@vue/composition-api'
import request from '@/utils/request'
import { Message } from 'element-ui'
import useRootSetting from '@/hooks/useRootSetting'
import CreateQuotation from "./createQuotation.vue";
export default defineComponent({
  name: 'Index',
  components: {CreateQuotation},
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: []
    }
  },
  setup(props,{emit}) {
    const instance = getCurrentInstance()
    const username = instance.proxy.$store.getters.name
    const { getIsMobile } = useRootSetting()
    const drawerVisible = ref<boolean>(false)
    const quotationDialog = ref<boolean>(false)
    const quotationData = ref<string[]>([])

    //购物车生成-报价单展示
    const handleQuotation = (data:any[]) => {
      drawerVisible.value = false
      quotationDialog.value = true
      quotationData.value = data
    }

    //已添加数据-单个删除
    const removeFromDrawer = ({ id }, index:number,channel: string) => {
      request({
        url: 'member_delete_cart.yy',
        method: 'post',
        data: { items: [{id: id,channel: channel}], username: username }
      }).then(res => {
        if (res.code == 200) {
          deleteRow(index)
          emit('removeFromDrawer',id)
        }
      }).catch(err => {
        Message({ message: err, type: 'error' })
      })
    }
    const deleteRow = (index:number) => {
      props.data.splice(index, 1)
    }
    //已添加数据-全部删除
    const handleClear = () => {
      const payload = {
        username: username,
        items: (props.data || []).map((item: { id: number; channel: number }) => ({
          id: item.id,
          channel: item.channel
        }))
      }
      request({
        url: 'member_delete_cart.yy',
        method: 'post',
        data: payload
      }).then(res => {
        if (res.code == 200) {
          Message.success(res.msg)
          // props.data = []
          // addedNum.value = 0
          emit('handleClear',payload.items)
        }
      }).catch(err => {
        Message({ message: err, type: 'error' })
      })
      drawerVisible.value = false
    }
    //报价单弹窗取消
    const handleCancel = () => {
      quotationDialog.value = false
    }
   //购物车弹窗关闭
    const createQuotation = () => {
      drawerVisible.value = false
    }
    //报价单弹窗关闭
    const handleClose = () => {
       emit('handleCloseAddCart')
    }

    watch(()=>props.dialog,(val)=>{
      drawerVisible.value = val
    },{immediate: true})
    return {
      quotationDialog,
      quotationData,
      drawerVisible,
      getIsMobile,
      handleClose,
      createQuotation,
      removeFromDrawer,
      handleQuotation,
      handleClear,
      handleCancel
    }
  }
})

